import { types } from "../types/types";

const initialState = {
  
  regulations: [],
  
  regulation: {},
  regulationSaved: {},
  regulationSelected: {},

  regulationsP: [],
  totalItemsRegulationP: 0,
  totalPagesRegulationP: 0,
  currentPageRegulationP: 0,

  regulationsS: [],
  totalItemsRegulationS: 0,
  totalPagesRegulationS: 0,
  currentPageRegulationS: 0,

  searchTextState: "",

  moreThanOneIsSelected: false,
  numberRegulationSelected: 0,

  isLoadingRegulations: false
};

/*
const countNumberIsSelected = (regulations) => {
  let countCompare = 0;
  regulations.forEach(element => {
    if(element.isSelected){
      countCompare ++;
    }
  });
  return countCompare;
}*/

const countSelected = (list) => list.filter(item => item.isSelected).length;

export const regulationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REGULATION_START_REGISTER_ADMIN:

      return {
        ...state,
        regulationSaved: action.payload,
      };

    case types.REGULATION_UPDATE:
      if (state.regulationsS.length > 0) {
        return {
          ...state,
          regulationsS: state.regulationsS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          regulationsP: state.regulationsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          regulationsP: state.regulationsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.REGULATION_DELETE:
      if (state.regulationsS.length > 0) {
        return {
          ...state,
          regulationsS: state.regulationsS.filter((usr) => usr.id !== action.payload),
          regulationsP: state.regulationsP.filter((usr) => usr.id !== action.payload),
          regulationSelected: {},
        };
      } else {
        return {
          ...state,
          regulationsP: state.regulationsP.filter((usr) => usr.id !== action.payload),
          regulationSelected: {},
        };
      }

    case types.REGULATION_START_LOADING_PAGINATED:
      return {
        ...state,
        regulationsP: action.payload.regulationsP,
        totalItemsRegulationP: action.payload.totalItems,
        totalPagesRegulationP: action.payload.totalPages,
        currentPageRegulationP: action.payload.currentPage,
      };

    case types.REGULATION_START_LOADING_REGULATION_PAGINATED:
      
      return {
        ...state,
        regulationsS: action.payload.regulationsP,
        totalItemsRegulationS: action.payload.totalItems,
        totalPagesRegulationS: action.payload.totalPages,
        currentPageRegulationS: action.payload.currentPage,
      };

    case types.REGULATION_START_SEARCH_PAGINATED:
      return {
        ...state,
        regulationsS: action.payload.regulationsP,
        totalItemsRegulationS: action.payload.totalItems,
        totalPagesRegulationS: action.payload.totalPages,
        currentPageRegulationS: action.payload.currentPage,
      };

    case types.REGULATION_SELECT:
      return {
        ...state,
        regulationSelected: action.payload,
      };

    case types.REGULATION_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        regulationsS: [],
        totalItemsRegulationS: 0,
        totalPagesRegulationS: 0,
        currentPageRegulationS: 0,
      };

    case types.REGULATION_CLEAN_PAGINATED:
      return {
        ...state,
        regulationsP: [],
        totalItemsRegulationP: 0,
        totalPagesRegulationP: 0,
        currentPageRegulationP: 0,

      };

    case types.REGULATION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.REGULATION_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.REGULATION_CLEAN_SAVED:
      return {
        ...state,
        regulationSaved: {},
      };

      /*
    case types.REGULATION_LIST_UPDATE_SELECTED:
      
      if (state.regulationsS.length > 0) {
        return {
          ...state,
          regulationsS: state.regulationsS.map((usr) => (usr.id === action.payload ? { ...usr, isSelected: !usr.isSelected } : usr)),

        };
      }
      break;
      */
     case types.REGULATION_LIST_UPDATE_SELECTED: {
           const id = action.payload;
           const currentSelectedCount = countSelected(state.regulationsS);
           const targetItem = state.regulationsS.find(item => item.id === id);
     
           // Si va a seleccionar uno nuevo y ya hay 9, no hacer nada
           if (!targetItem.isSelected && currentSelectedCount >= 9) return state;
     
           const newRegulations = state.regulationsS.map(item =>
             item.id === id ? { ...item, isSelected: !item.isSelected } : item
           );
     
           const newCount = countSelected(newRegulations);
     
           return {
             ...state,
             regulationsS: newRegulations,
             numberRegulationSelected: newCount,
             moreThanOneIsSelected: newCount > 1
           };
         }
     
         // Selección masiva (Primeros 9 o todos si hay menos)
         case types.REGULATION_SELECT_ALL_LIMIT: {
           const newRegulations = state.regulationsS.map((item, index) => ({
             ...item,
             isSelected: index < 9 // Selecciona solo los primeros 9
           }));
     
           const newCount = countSelected(newRegulations);
     
           return {
             ...state,
             regulationsS: newRegulations,
             numberRegulationSelected: newCount,
             moreThanOneIsSelected: newCount > 1
           };
         }
     
         // Limpiar todo
         case types.REGULATION_CLEAN_ALL_SELECTED: {
           return {
             ...state,
             regulationsS: state.regulationsS.map(item => ({ ...item, isSelected: false })),
             numberRegulationSelected: 0,
             moreThanOneIsSelected: false
           };
         }

    case types.REGULATION_GET_MORE_THAN_ONE_SELECTED:
      //console.log("reducer, GET_MORE_THAN_ONE_SELECTED")
      if (state.regulationsS.length > 0) {
        //console.log("state.regulationsS.length", state.regulationsS.length)
        return {
          ...state,
          moreThanOneIsSelected: getMoreThanOneIsSelected(state)
        };
      }
      break;

    case types.REGULATION_LIST_SET_NUMBER_SELECTED:
      //console.log("REGULATION_LIST_SET_NUMBER_SELECTED, action.payload", action.payload)
      if (state.regulationsS.length > 0) {
        return {
          ...state,
          numberRegulationSelected: action.payload
        };
      }
      break;

    case types.REGULATION_CLEAN_SEARCH_INFORMATION:
      return {
        ...state,
        numberRegulationSelected: 0
      };

             case types.REGULATION_IS_LOADING:

        return {
          ...state,
          isLoadingRegulations: true
        };
    
      case types.REGULATION_IS_LOADING_FINISH:

        return {
          ...state,
          isLoadingRegulations: false
        };

    default:
      return state;
  }
};

const getMoreThanOneIsSelected = (state) => {
  //console.log("state.getMoreThanOneIsSelected", state.getMoreThanOneIsSelected);

  let flagMoreThanOne = false;
  let counterFlagMoreThanOneIsSelected = 0;

  if (state.regulationsS.length > 0) {
    state.regulationsS.forEach(element => {

      if (element.isSelected) {
        //console.log("element.isSelected", element.isSelected)
        counterFlagMoreThanOneIsSelected = counterFlagMoreThanOneIsSelected + 1;
      }
      //console.log("la cuenta esta en, counterFlagMoreThanOneIsSelected", counterFlagMoreThanOneIsSelected);
    });
  }

  if (counterFlagMoreThanOneIsSelected > 1) {
    //console.log("counterFlagMoreThanOneIsSelected", counterFlagMoreThanOneIsSelected)
    flagMoreThanOne = true;
  }

  return flagMoreThanOne;
}